import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { ReplaySubject, Subject } from 'rxjs';
import { filter, takeWhile } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as fromDataServices from '../../data-services';
import { PayrollItem } from '../../payroll/item/store';
import * as fromShared from '../../shared';
import { MultiSelect, Table } from '../../shared';
import { columnResize } from '../../shared/columnResize';
import { UnsavedChangesService } from '../../shared/modal-dialog';
import { LoggingService } from '../../shared/services/logging';
import { IUserInfo } from '../../user-info';
@Component({
    selector: 'ef-manage-users-presenter',
    templateUrl: './manage-users-presenter.component.html',
    styleUrls: ['./manage-users-presenter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ManageUsersPresenterComponent
    extends fromShared.EditGrid<fromDataServices.ManageUsers.LoginModel>
    implements OnInit, OnDestroy, AfterViewInit, OnChanges
{
    selection: fromDataServices.ManageUsers.LoginModel[];
    @Input() qboEnabled = false;
    @Input() loading = false;
    @Input() supervisors: fromShared.SelectItem[];
    @Input() daysOfWeek: fromShared.SelectItem[];
    @Input() activeServiceItems: fromShared.SelectItem[];
    @Input() serviceItems: fromShared.SelectItem[];
    @Input() payrollItems: PayrollItem[];
    @Input() mobileProviders: fromShared.SelectItem[];
    @Input() splitdays: fromShared.SelectItem[];
    @Input() creditCards: fromShared.SelectItem[];
    @Input() timeZones: fromShared.SelectItem[];
    @Input() messageDeliveryTypes: fromShared.SelectItem[];
    @Input() costCenters: fromShared.SelectItem[];
    //@Input() payrollFrequency: fromShared.SelectItem[];
    public Array = Array;
    private PayrollFrequencySubject = new ReplaySubject<
        fromShared.SelectItem[]
    >(1);
    private _payrollfrequency: fromShared.SelectItem[];
    @Input() set payrollFrequency(value: fromShared.SelectItem[]) {
        if (value && value.length > 0) {
            value.unshift({
                label: '',
                value: 0
            });
            this._payrollfrequency = value;
            this.PayrollFrequencySubject.next(this._payrollfrequency);
        }
    }
    get payrollFrequency(): fromShared.SelectItem[] {
        return this._payrollfrequency;
    }
    @Input() userTypes: fromShared.SelectItem[];
    @Input() emailEnabled: boolean;
    @Input() userInfo: IUserInfo;
    @Input() height: number;
    @Input() updateBulkLogins: any;
    @Output() SendCredentials = new EventEmitter<
        fromDataServices.ManageUsers.LoginModel[]
    >();
    @Output() ShowInactive = new Subject<boolean>();
    @ViewChild('msPersonFilter', { static: true }) msPersonFilter: MultiSelect;
    @ViewChild('dataTable') myTable: Table;
    ItemsChangeSubject = new Subject<
        fromDataServices.ManageUsers.LoginModel[]
    >();
    personSelectItemsSubject = new ReplaySubject<fromShared.SelectItem[]>(1);
    supervisorsSelectItemsSubject = new ReplaySubject<fromShared.SelectItem[]>(
        1
    );
    siSelectItemsSubject = new ReplaySubject<fromShared.SelectItem[]>(1);
    piSelectItemsSubject = new ReplaySubject<fromShared.SelectItem[]>(1);
    userType = 'All';
    showInactive = false;
    selectedPeopleFilter: fromShared.SelectItem[];
    dropdownItemHeight = environment.dropdownItemHeight;
    downloadOptions = [
        {
            label: 'CSV',
            icon: 'pi pi-download',
            command: () => this.dataTable.exportCSV()
        }
    ];
    payrollSelectItems: fromShared.SelectItem[];
    moment: any;
    numCols = 31;
    environment = environment;
    sendCredentialsForm: UntypedFormGroup;
    private active = true;
    timeChecked: boolean = true;
    expenseChecked: boolean = true;
    remindersChecked: boolean = true;
    processingChecked: boolean = true;
    columnSearchValue: string;
    columnIndex: number;
    elements: HTMLCollection;
    cols = [
        { header: 'Person', field: 'EmployeeName' },
        { header: 'Active', field: 'IsActive' },
        { header: 'Type', field: 'TypeDesc' },
        { header: 'Account #', field: 'AccountNumber' },
        { header: 'User ID', field: 'EUserID' },
        //{ header: 'Password', field: 'EPassword' },
        { header: 'Supervisor', field: 'SupervisorName' },
        { header: 'Week Start', field: 'WeekStartName' },
        { header: 'Default SI', field: 'DefaultServiceItemName' },
        { header: 'Default PI', field: 'DefaultPayrollItemName' },
        { header: 'Holiday Auths', field: 'AuthorizedHolidays' },
        { header: 'Mobile #', field: 'Mobilewithprovider' },
        { header: 'Split Day', field: 'SplitDayName' },
        { header: 'Expense Entry', field: 'ExpenseAllowed' },
        { header: 'Credit Card', field: 'CreditCardName' },
        { header: 'Email', field: 'EmailAddr' },
        { header: 'Expected Hrs Per Day', field: 'Expectedhrsperday' },
        { header: 'Expected Hrs Per Week', field: 'Expectedhrsperweek' },
        { header: 'Do Not Remind', field: 'IsPartTime' },
        { header: 'Time Zone', field: 'EmpTimeZone' }, //find desc
        { header: 'Reminder Delivery', field: 'ReminderDeliveryName' },
        { header: 'Cost Center', field: 'CostCenterName' },
        { header: 'Unique Pay Cycle', field: 'PayrollFrequency' }, //find desc
        { header: 'Usertype', field: 'Usertype' },
        { header: 'Hire Date', field: 'HireDate', class: 'date' },
        { header: 'Release Date', field: 'ReleaseDate', class: 'date' },
        { header: 'Lock Out', field: 'LockDate', class: 'date' },
    ];
    IsColumnFrozen = false;
    IsSupervisorColumnFrozen = false;
    constructor(
        private log: LoggingService,
        private confirmservice: UnsavedChangesService,
        public cdRef: ChangeDetectorRef
    ) {
        super();
        this.moment = moment;
        this.sendCredentialsForm = new UntypedFormGroup({
            Subject: new UntypedFormControl(),
            Message: new UntypedFormControl(),
            eFAACTLink: new UntypedFormControl('efaactcentral.com'),
            introLink: new UntypedFormControl('wheredoesthisgo.com')
        });
    }

    ngOnInit(): void {}
    ngOnDestroy(): void {
        this.active = false;
    }
    ngAfterViewInit(): void {
        if (this.myTable) {
            this.myTable.resetScrollTop = function () { };
        }
        this.IsColumnFrozen = true;
        // sets the inital list for person filter
        this.ItemsChangeSubject.pipe(
            takeWhile(() => this.active),
            filter(x => !!x && x.length > 0)
            // take(1)
        ).subscribe(items => {
            this.personSelectItemsSubject.next(
                items
                    // .filter(x => x.IsActive)
                    .map(item => ({
                        label: item.EmployeeName,
                        value: item.EmployeeListID
                    }))
            );
            const siSI = items.map(item => ({
                label: item.DefaultServiceItemName,
                value: item.DefaultServiceItemName
            }));
            const uniqueSISelectItem = fromShared.uniqBy(
                siSI,
                x => x.label
            );
            this.siSelectItemsSubject.next(
                uniqueSISelectItem
            );
            const piSI = items.map(item => ({
                label: item.DefaultPayrollItemName,
                value: item.DefaultPayrollItemName
            }));
            const uniquePISelectItem = fromShared.uniqBy(
                piSI,
                x => x.label
            );
            this.piSelectItemsSubject.next(
                uniquePISelectItem
            );
        });
        setTimeout(() => {
            this.elements = document.getElementsByClassName('p-header-cell');
        }, 0);
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        this.log.verbose({
            type: 'ManageUsersComponent:ngOnChanges',
            changes
        });
        if (changes.payrollItems) {
            this.payrollSelectItems = changes.payrollItems.currentValue.map(
                item => ({
                    label: item.PayrollItem,
                    value: item.PIListID
                })
            );
        }
        if (changes.items) {
            this.ItemsChangeSubject.next(changes.items.currentValue);
            this.selected = [];
            this.SelectItem.next([]);
        }
        if (
            changes.supervisors &&
            changes.supervisors.currentValue.length > 0
        ) {
            this.supervisorsSelectItemsSubject.next(
                changes.supervisors.currentValue
            );
        }
        if (changes.updateBulkLogins) {
            this.selected = [];
            this.SelectItem.next([]);
        }
    }
    trackByEmployee(index: number, item: fromDataServices.ManageUsers.LoginModel): string | undefined {
        return item ? item.EmployeeName : undefined;
    }
    toggleLockColumn(column, event: MouseEvent) {
        if (event) {
            event.stopPropagation();
        }
        if (column == 'supervisor') {
            this.IsSupervisorColumnFrozen = !this.IsSupervisorColumnFrozen;
        }
    }
    onColumnResize($event) {
        var table = document.querySelector('table');
        columnResize($event, 4, table);
    }
    onRowEditInit(item: fromDataServices.ManageUsers.LoginModel) {
        super.onRowEditInit(item);
        this.payrollSelectItems = fromShared
            .uniqBy(
                this.payrollItems
                    .filter(pi => pi.EmployeeListID === item.EmployeeListID)
                    .map(pi => ({
                        value: pi.PIListID,
                        label: pi.PayrollItem
                    })),
                x => x.value
            )
            .sort((a, b) => a.label.localeCompare(b.label));
    }
    searchTextChanged() {
        this.columnIndex = null;
    }
    scrollToColumn(id) {
        var elements = document.getElementsByClassName('p-header-cell');
        var ele;
        var elementsArr = Array.from(elements);
        var filteredElements = elementsArr.filter(x =>
            x.textContent.toLowerCase().trim().includes(id)
        );
        for (var i = 0; i < filteredElements.length; i++) {
            if (this.columnIndex != null) {
                if (i > +this.columnIndex) {
                    ele = filteredElements[i];
                    this.columnIndex = i;
                    ele.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center'
                    });
                    if (filteredElements.length - 1 == i) {
                        this.columnIndex = null;
                    }
                    break;
                }
            } else {
                if (filteredElements[i]) {
                    ele = filteredElements[i];
                    this.columnIndex = i;
                    ele.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center'
                    });
                    break;
                }
            }
        }
    }
    onSendCredentials(logins: fromDataServices.ManageUsers.LoginModel[]) {
        this.log.verbose({
            type: 'ManageUsersComponent:sendCredentials',
            logins
        });
        this.confirmservice
            .confirmPromise({ dialogText: 'For selected users, this action assigns a new password and sends an email with their updated login credentials.  Are you sure?' })
            .then(() => {
                this.SendCredentials.next(logins);
                $(`#btnSendcredentials`).removeClass('blinking');
            })
            .catch(() => {});
    }
    filterUserType(type: string) {
        this.log.verbose({
            type: 'ManageUsersComponent:filterUserType',
            userType: type
        });
        switch (type.toLocaleLowerCase()) {
            case 'all':
                this.dataTable.filter('', 'IsConsultant', 'contains');
                break;
            case 'consultant':
                this.dataTable.filter(1, 'IsConsultant', 'equals');
                break;
            case 'employee':
                this.dataTable.filter(0, 'IsConsultant', 'equals');
                break;
            default:
                break;
        }
    }
    dataTableFilter(event: {
        filters: any;
        filteredValue: fromDataServices.ManageUsers.LoginModel[];
    }) {
        this.log.verbose({
            type: 'ManageUsersComponent:dataTableFilter',
            event
        });
        if (!event.filters.EmployeeListID) {
            this.personSelectItemsSubject.next(
                event.filteredValue.map(item => ({
                    label: item.EmployeeName,
                    value: item.EmployeeListID
                }))
            );
            if (!event.filters.SupervisorListID) {
                this.supervisorsSelectItemsSubject.next(this.supervisors);
            }
        }
        if (
            !event.filters.SupervisorListID &&
            event.filters.EmployeeListID &&
            event.filters.EmployeeListID.value &&
            event.filters.EmployeeListID.value.length > 0
        ) {
            const logins = this.items.filter(x =>
                (event.filters.EmployeeListID.value as Array<string>).includes(
                    x.EmployeeListID as string
                )
            );
            this.supervisorsSelectItemsSubject.next(
                this.supervisors.filter(s =>
                    logins.map(x => x.SupervisorListID).includes(s.value)
                )
            );
        }
        if (!event.filters.DefaultServiceItemName) {
            const uniqueSIFilteredValue = fromShared.uniqBy(
                event.filteredValue,
                x => x.DefaultServiceItemName
            );
            this.siSelectItemsSubject.next(
                uniqueSIFilteredValue.map(item => ({
                    label: item.DefaultServiceItemName,
                    value: item.DefaultServiceItemName
                }))
            );
        }
        if (!event.filters.DefaultPayrollItemName) {
            const uniquePIFilteredValue = fromShared.uniqBy(
                event.filteredValue,
                x => x.DefaultPayrollItemName
            );
            this.piSelectItemsSubject.next(
                uniquePIFilteredValue.map(item => ({
                    label: item.DefaultPayrollItemName,
                    value: item.DefaultPayrollItemName
                }))
            );
        }
    }
    onShowInactiveChange(showInactive) {
        this.log.verbose({
            type: 'ManageUsersComponent:onShowInactiveChange',
            showInactive: this.showInactive,
            value: showInactive
        });
        this.selectedPeopleFilter = [];
        this.dataTable.filter('', 'EmployeeListID', 'contains');
        this.ShowInactive.next(showInactive);
        // if (showInactive) {
        //     this.dataTable.filter('', 'IsActive', 'contains');
        // } else {
        //     this.dataTable.filter(true, 'IsActive', 'equals');
        // }
        // this.dataTable.filter(showInactive ? '' : !showInactive, 'IsActive', showInactive ? 'contains' : 'equals');
    }
}
